import onLoad from './staging/onLoad';
import onLoadShared from './staging/onLoadShared';
import onSubmitForgotPassword from './staging/onSubmitForgotPassword';
import onSubmitResetPassword from './staging/onSubmitResetPassword';

export default {
  onLoad,
  onLoadShared,
  onSubmitForgotPassword,
  onSubmitResetPassword,
};
